import { useTypedSelector } from './use-typed-selector';

export const useCumulativeCode = (cellId: string) =>
  useTypedSelector((state) => {
    const { data, order } = state.cells;
    const orderedCells = order.map((id) => data[id]);

    // React is only be imported once, even user add another import
    // esbuild will create two different variable with slightly different namespaces
    const showFuc = `
    import _React from 'react'
    import _ReactDOM from 'react-dom'

    var show = (value) => {
      const root = document.querySelector('#root');
      if (typeof value === 'object') {
        if (value.$$typeof && value.props) {
          _ReactDOM.render(value, root)
        } else {
          root.innerHTML = JSON.stringify(value);
        }
      } else {
        root.innerHTML = value;
      }
    }`;
    // handling two cell show once logic
    const showFucNoop = 'var show = () => {}';

    const cumCodes: string[] = [];
    orderedCells.some((c) => {
      if (c.type === 'code') {
        if (c.id === cellId) {
          cumCodes.push(showFuc);
        } else {
          cumCodes.push(showFucNoop);
        }
        cumCodes.push(c.content);
      }
      return c.id === cellId;
    });
    return cumCodes;
  }).join('\n');
